import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { of, Subject, throwError } from 'rxjs';
import { catchError, finalize, switchMap, takeUntil } from 'rxjs/operators';

import { TmpI18NService } from 'app/i18n/tmp-i18n.service';
import { UserService } from 'app/user/user.service';

import { AuthService } from '../auth.service';

@Component({
  template: '',
})
export class LoginRedirectComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly oidcSecurityService: OidcSecurityService,
    private readonly authService: AuthService,
    private readonly i18nService: TmpI18NService,
  ) {}

  ngOnInit(): void {
    this.oidcSecurityService
      .checkAuth()
      .pipe(
        takeUntil(this.destroy$),
        switchMap(({ isAuthenticated }) => {
          if (isAuthenticated) {
            return this.userService.updateCurrentUser();
          }

          return of(null);
        }),
        finalize(() => {
          const customRedirectUrl = this.authService.getCustomAuthRedirectURL();

          if (customRedirectUrl) {
            this.authService.clearCustomAuthRedirectURL();
            return this.router.navigateByUrl(customRedirectUrl);
          }

          return this.router.navigate(['/']);
        }),
        catchError((error) => {
          const isUndefinedState = JSON.stringify(error).includes('could not find matching config for state');

          if (isUndefinedState) {
            const message = this.i18nService.getMessage('loginRedirectErrorMessage');
            this.authService.showRedirectionModal(message);
            return of(null);
          }

          return throwError(error);
        }),
      )
      .subscribe({
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        error: (error) => {
          // TODO: there is currently an error thrown after password recovery login.
          //       The issue is that the operation is initiated in email, and the
          //       web app does not know the state parameter when a user is redirected
          //       to the web app after successful password recovery. The issue is not critical,
          //       because it is automatically solved by making another redirect to the login page in FA
          // this.errorHandler.handle(error);
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
